import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import useGameStore from '../../../../hooks/useGameStore'

const commentDefaultData = [
  {
    index: 0,
    value: '픽을 선택하신 후 간단한 문구를 선택하세요.',
    label: '픽을 선택하신 후 간단한 문구를 선택하세요.',
  },
  {
    index: 1,
    value: '지금까지 이런 흐름은 없었다. 이것은 신인가 컴퓨터인가?',
    label: '지금까지 이런 흐름은 없었다. 이것은 신인가 컴퓨터인가?',
  },
  {
    index: 2,
    value: '펭하~! 펭수도 이런 흐름에는 고민없이 갑니다.',
    label: '펭하~! 펭수도 이런 흐름에는 고민없이 갑니다.',
  },
  {
    index: 3,
    value: '신사답게 행동해~! 묻고 흐름타서 떠블로 가!',
    label: '신사답게 행동해~! 묻고 흐름타서 떠블로 가!',
  },
  { index: 4, value: '니 내가 누군지 아니? 내 런닝볼 장인이야!', label: '니 내가 누군지 아니? 내 런닝볼 장인이야!' },
  {
    index: 5,
    value: '런닝볼 숫자 적중은 네임드! 언오버 적중도 네!임!드!',
    label: '런닝볼 숫자 적중은 네임드! 언오버 적중도 네!임!드!',
  },
  {
    index: 6,
    value: '런닝볼 숫자는 지리구요. 언오버는 오지구요.',
    label: '런닝볼 숫자는 지리구요. 언오버는 오지구요.',
  },
  {
    index: 7,
    value: '언오버를 지배하는 자가 런닝볼을 지배합니다.',
    label: '언오버를 지배하는 자가 런닝볼을 지배합니다.',
  },
  { index: 8, value: '제 픽은 정말 현명한 선택이에요.', label: '제 픽은 정말 현명한 선택이에요.' },
  {
    index: 9,
    value: '어디로 갈지 망설이지 말고 저를 전적으로 믿으셔야합니다.',
    label: '어디로 갈지 망설이지 말고 저를 전적으로 믿으셔야합니다.',
  },
  { index: 10, value: '이안에 픽있다. 런닝볼아 가자~!', label: '이안에 픽있다. 런닝볼아 가자~!' },
]

const commentPlaceholder = '먼저 픽을 선택하신후 픽리스트에 나타낼 간단한 문구를 입력하세요.'

const PickComment = observer(({ gameType, pickType, items, totalCnt, date, round }) => {
  const gameStore = useGameStore()
  const [page, setPage] = useState(1)
  const totalPage = Math.ceil(totalCnt / 10)

  useEffect(() => {
    setPage(1)
  }, [gameType, pickType, date, round])

  const onClickNextPage = () => {
    let getPickCommentList = gameStore.getLotteryPickCommentList
    if (gameType === 'ladder' || gameType === 'speed_ladder' || gameType === 'daridari') {
      getPickCommentList = gameStore.getThemePickCommentList
    }
    getPickCommentList({
      gameType: gameType,
      pickType: pickType === 'all' ? null : pickType,
      limit: 10,
      offset: page * 10,
      date: date,
      round: round,
    })

    setPage(page + 1)
  }

  const pickInfo = {
    powerball_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '파워볼',
    },
    powerball_under_over: {
      under: { pick: '언더', class: 'UNDER' },
      over: { pick: '오버', class: 'OVER' },
      pickType: '파워볼',
    },
    powerball_section: {
      a: { pick: 'A', class: 'A' },
      b: { pick: 'B', class: 'A' },
      c: { pick: 'C', class: 'A' },
      d: { pick: 'D', class: 'A' },
      pickType: '파워볼',
    },
    powerball_odd_even_under_over: {
      odd_under: { pick: '홀언', class: 'ODD' },
      odd_over: { pick: '홀오', class: 'ODD' },
      even_under: { pick: '짝언', class: 'EVEN' },
      even_over: { pick: '짝오', class: 'EVEN' },
      pickType: '파워볼',
    },
    sum_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '일반볼',
    },
    sum_under_over: {
      under: { pick: '언더', class: 'UNDER' },
      over: { pick: '오버', class: 'OVER' },
      pickType: '일반볼',
    },
    sum_size: {
      l: { pick: '대', class: 'EVEN' },
      m: { pick: '중', class: 'ODD' },
      s: { pick: '소', class: 'SMALL' },
      pickType: '일반볼',
    },
    sum_odd_even_under_over: {
      odd_under: { pick: '홀언', class: 'ODD' },
      odd_over: { pick: '홀오', class: 'ODD' },
      even_under: { pick: '짝언', class: 'EVEN' },
      even_over: { pick: '짝오', class: 'EVEN' },
      pickType: '일반볼',
    },
    sum_odd_even_size: {
      odd_large: { pick: '홀대', class: 'ODD' },
      odd_medium: { pick: '홀중', class: 'ODD' },
      odd_small: { pick: '홀소', class: 'ODD' },
      even_large: { pick: '짝대', class: 'EVEN' },
      even_medium: { pick: '짝중', class: 'EVEN' },
      even_small: { pick: '짝소', class: 'EVEN' },
      pickType: '일반볼',
    },
    start: {
      right: { pick: '우', class: 'ODD' },
      left: { pick: '좌', class: 'EVEN' },
      pickType: '출발',
    },
    line: {
      3: { pick: '3', class: 'ODD' },
      4: { pick: '4', class: 'EVEN' },
      pickType: '줄수',
    },
    combination: {
      l3e: { pick: '좌3', class: 'EVEN' },
      l4o: { pick: '좌4', class: 'ODD' },
      r3o: { pick: '우3', class: 'ODD' },
      r4e: { pick: '우4', class: 'EVEN' },
      pickType: '출발+줄수',
    },
    odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '결과',
    },
    last_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '',
    },
    under_over: {
      under: { pick: '언더', class: 'UNDER' },
      over: { pick: '오버', class: 'OVER' },
      pickType: '',
    },
    runningball_under_over: {
      under: { pick: '언더', class: 'UNDER' },
      over: { pick: '오버', class: 'OVER' },
      pickType: '1등볼',
    },
    runningball_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '1등볼',
    },
    rank: {
      1: { pick: '1번', class: 'ODD' },
      2: { pick: '2번', class: 'EVEN' },
      3: { pick: '3번', class: 'ODD' },
      4: { pick: '4번', class: 'EVEN' },
      pickType: '일반볼',
    },
    last_under_over: {
      under: { pick: '언더', class: 'UNDER' },
      over: { pick: '오버', class: 'OVER' },
      pickType: '',
    },

    count_win: {
      home: { pick: '좌', class: 'HOME' },
      draw: { pick: '무', class: 'DRAW' },
      away: { pick: '우', class: 'AWAY' },
      pickType: '볼 갯수 승무패',
    },
    sum_win: {
      home: { pick: '좌', class: 'HOME' },
      draw: { pick: '무', class: 'DRAW' },
      away: { pick: '우', class: 'AWAY' },
      pickType: '볼 번호 합산 승무패',
    },
    sum_home_ball_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      0: { pick: '0', class: 'ZERO' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '좌측 번호 합 홀짝',
    },
    sum_away_ball_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      0: { pick: '0', class: 'ZERO' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '우측 번호 합 홀짝',
    },
    home_ball1_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      0: { pick: '0', class: 'ZERO' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '좌측 1등볼 홀짝',
    },
    away_ball1_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      0: { pick: '0', class: 'ZERO' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '우측 1등볼 홀짝',
    },
    home_ball1_under_over: {
      under: { pick: '홀', class: 'UNDER' },
      0: { pick: '0', class: 'ZERO' },
      over: { pick: '짝', class: 'OVER' },
      pickType: '좌측 1등볼 홀짝',
    },
    away_ball1_under_over: {
      under: { pick: '홀', class: 'UNDER' },
      0: { pick: '0', class: 'ZERO' },
      over: { pick: '짝', class: 'OVER' },
      pickType: '우측 1등볼 언오버',
    },

    ball_1_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '1번볼 (빨간색)',
    },
    ball_2_odd_even: {
      odd: { pick: '홀', class: 'ODD' },
      even: { pick: '짝', class: 'EVEN' },
      pickType: '2번볼 (노란색)',
    },
  }

  const getPickCommentList = (item) => {
    const info = pickInfo[item.pick_type]
    const pickClass = 'ic ' + info[item.pick]['class']
    const pickText = info[item.pick]['pick']
    let pickType = info['pickType']

    if (gameType.startsWith('running') && pickType === '일반볼') {
      pickType = '123등 합'
    }
    let data = null
    if (gameType === 'powerball' || gameType.startsWith('running')) {
      data = '<dt class="' + pickClass + '">' + pickText + '</dt>  <dd class="type"> ' + pickType + '</dd>'
    } else {
      data = `
            <dt class="${pickClass}">${pickText}</dt>
            <dd class="type">${pickType}</dd>
            `
    }

    return data
  }

  return (
    <>
      {items &&
        items.map((item, i) => {
          return (
            <div className='item' key={i}>
              <dl className='pick' dangerouslySetInnerHTML={{ __html: getPickCommentList(item) }}></dl>
              <div className='talk'>{item.comment}</div>
              <div className='nick'>{item.mb_nick}</div>
            </div>
          )
        })}
      {totalCnt > 10 && page < totalPage && (
        <button className='btn_more' onClick={onClickNextPage}>
          더보기 ({page}/{totalPage})
        </button>
      )}
    </>
  )
})

export { PickComment, commentDefaultData, commentPlaceholder }
